import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  openPreferencesView: false,
};

export const userPreferencesSlice = createSlice({
  name: 'userPreferencesStore',
  initialState,
  reducers: {
    SET_OPEN_PREFERENCES_VIEW: (state, action: PayloadAction<boolean>) => {
      state.openPreferencesView = action.payload;
    },
  },
});

export const { SET_OPEN_PREFERENCES_VIEW } = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;
